import axios from "axios";

async function getRequest(url, id) {
    if (id) {
        url = url + "/" + id;
    }

    const response = await axios.get(url);

    return response;
}
async function postRequest(url, data, id) {
    if (id) {
        url = url + "/" + id;
    }
    const headers = {
        'accept: ': '*/*',
        "Content-Type": "application/json-patch+json",
    }
    let urls = "http://api.heryerdeingilizce.com/api/User/Authorize";
    //let urls = "https://localhost:7004/api/User/Authorize";
    const response = await axios.post(url, data);


    console.log(response);
    return response;
}

async function updateRequest(url, data, id) {
    if (id) {
        url = url + "/" + id;
    }
    const response = await axios.put(url, data);
    return response;
}

async function deleteRequest(url, id) {
    if (id) {
        url = url + "/" + id;
    }
    const response = await axios.delete(url);
    return response;
}



const RequestHelper = async (subUrl, reqType, data, id) => {
    const baseUrl = "https://api.heryerdeingilizce.com";
    //const baseUrl = "http://localhost:7004";
    const url = baseUrl + subUrl;
    //const url = "http://www.api.heryerdeingilizce.com/api/User/Authorize";
    let response = [];
    alert(subUrl)
    if (reqType === "get") {
        response = await getRequest(url, id);
    }
    else if (reqType === "post") {
        response = await postRequest(url, data, id);
    }
    else if (reqType === "delete") {
        response = await deleteRequest(url, id);
    }
    else if (reqType === "put") {
        response = await updateRequest(url, data, id);
    }
    //console.log(response);
    return response;

    //return status 200 değilse mesajı gelsin buraya
    //localstoragedden baerer token çek
}




export default RequestHelper;
